type LogRecord = {
  timestamp: string;
  method: string;
  host: string;
  path: string;
  status_code: number;
  ip: string;
  user_agent: string;
  referer?: string;
  bytes_sent?: number;
  duration_ms?: number;
  query_params?: Record<string, string | string[]>;
};

export function sendProfoundLogs(batch: LogRecord[]) {
  try {
    fetch('https://artemis.api.tryprofound.com/v1/logs/custom', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'x-api-key': `${process.env.PROFOUND_API_KEY}`,
      },
      body: JSON.stringify(batch),
    }).catch(() => {});
  } catch (error) {
    console.error('Error sending Profound logs:', error);
  }
}
